// ---------------------------------------------------//
// ----------------Directions and prices--------------//
// ---------------------------------------------------//


let namesLocations = {}; // названия всех направлений в нашей системе (ключ+значение)

function getNamesLocationsByLanguage(language){
  if(language=="ru"){
      namesLocations = {
        cataniaairport: "Катания аэропорт",
        cataniacenter: "Катания центр",
        cataniaport: "Катания порт",
        taormina: "Таормина",
        castelmola: "Кастельмола",
        giardininaxos: "Джардини Наксос",
        letojanni: "Летоянни",
        siracusa: "Сиракуза",
        augusta: "Аугуста",
        brucoli: "Бруколи",
        noto: "Ното",
        fontanebianche: "Фонтане Бьянке",
        lidodinoto: "Лидо-ди-Ното",
        marzamemi: "Мардзамеми", 
        ragusa: "Рагуза", 
        marinadiragusa: "Марина-ди-Рагуза", 
        modica: "Модика", 
        marinadimodica: "Марина-ди-Модика", 
        comisocenter: "Комизо центр",  
        comisoairport: "Комизо аэропорт", 
        vittoria: "Витториа", 
        lentini: "Лентини", 
        carlentini: "Карлентини", 
        vizzini: "Виццини", 
        francofonte: "Франкофонте", 
        agrigento: "Агридженто", 
        gela: "Джела", 
        licata: "Ликата", 
        caltagirone: "Кальтаджироне", 
        caltanissetta: "Кальтаниссетта", 
        enna: "Энна",  
        piazzaarmerina: "Пьяцца-Армерина", 
        cefalu: "Чефалу", 
        palermocenter: "Палермо центр", 
        mondello: "Монделло", 
        palermoairport: "Палермо аэропорт", 
        bagheria: "Багериа", 
        santaflavia: "Санта Флавиа", 
        villabate: "Виллабате", 
        campofelicediroccella: "Кампо-Феличе-ди-Рочелла", 
        santagatadimilitello: "Сант-Агата-ди-Милителло", 
        capodorlando: "Капо д'Орландо", 
        gioiosamarea: "Джойоза Мареа", 
        brolo: "Броло", 
        patti: "Патти", 
        barcellonapozzodigotto: "Барчелона Поццо-ди-Готто", 
        portorosaport: "Портороза порт", 
        milazzoport: "Милаццо порт", 
        milazzocenter: "Милаццо центр", 
        messinaport: "Мессина порт", 
        messinacenter: "Мессина центр", 
        aliterme: "Али Терме", 
        nizzadisicilia: "Ницца-ди-Сицилия", 
        roccalumera: "Роккалумера", 
        furcisiculo: "Фурчи Сикуло", 
        santateresa: "Санта Тереза", 
        savoca: "Савока", 
        forzadagro: "Форца д'Агро", 
        santalessio: "Сант-Алессио", 
        randazzo: "Рандаццо", 
        bronte: "Бронте", 
        linguaglossa: "Лингуаглосса город", 
        etnanord: "Этна, северный склон (Лингуаглосса)",
        etnasud: "Этна, южный склон (Николози)",
        santavenerina: "Санта Венерина", 
        zafferana: "Дзафферана", 
        milo: "Мило", 
        solicchiata: "Соликкьята", 
        rovittello: "Ровиттелло", 
        piedimonteetneo: "Пьедимонте Этнео",  
        fiumefreddodisicilia: "Фьюмефреддо-ди-Сичилья", 
        calatabiano: "Калатабьяно", 
        mascali: "Маскали", 
        giarre: "Джарре", 
        acireale: "Ачиреале", 
        ripostoport: "Рипосто порт", 
        ribera: "Рибера", 
        sciacca: "Шакка", 
        mazaradelvallo: "Мадзара-дел-Валло", 
        marsala: "Марсала",  
        trapanicenter: "Трапани центр", 
        trapaniport: "Трапани порт", 
        trapaniairport: "Трапани аэропорт",  
        sanvitolocapo: "Сан-Вито-ло-Капо", 
        pozzallo: "Поццалло", 
        villasangiovanni: "Вилла-Сан-Джованни",
        reggiocalabriacity: "Реджо-Калабрия центр",
        reggiocalabriaairport: "Реджо-Калабрия аэропорт",
        lameziatermecity: "Ламеция Терме центр",
        lameziatermeairport: "Ламеция Терме аэропорт"
      }; 
  }else if(language=="it"){
      namesLocations = {
        cataniaairport: "Catania Aeroporto",
        cataniacenter: "Catania Centro",
        cataniaport: "Catania Porto",
        taormina: "Taormina",
        castelmola: "Castelmola",
        giardininaxos: "Giardini Naxos",
        letojanni: "Letojanni",
        siracusa: "Siracusa",
        augusta: "Augusta",
        brucoli: "Brucoli",
        noto: "Noto",
        fontanebianche: "Fontane Bianche",
        lidodinoto: "Lido di Noto",
        marzamemi: "Marzamemi", 
        ragusa: "Ragusa", 
        marinadiragusa: "Marina di Ragusa", 
        modica: "Modica", 
        marinadimodica: "Marina di Modica", 
        comisocenter: "Comiso Centro",  
        comisoairport: "Comiso Aeroporto", 
        vittoria: "Vittoria", 
        lentini: "Lentini", 
        carlentini: "Carlentini", 
        vizzini: "Vizzini", 
        francofonte: "Francofonte", 
        agrigento: "Agrigento", 
        gela: "Gela", 
        licata: "Licata", 
        caltagirone: "Caltagirone", 
        caltanissetta: "Caltanissetta", 
        enna: "Enna",  
        piazzaarmerina: "Piazza Armerina", 
        cefalu: "Cefalù", 
        palermocenter: "Palermo Centro", 
        mondello: "Mondello", 
        palermoairport: "Palermo Aeroporto", 
        bagheria: "Bagheria", 
        santaflavia: "Santa Flavia", 
        villabate: "Villabate", 
        campofelicediroccella: "Campo Felice di Roccella", 
        santagatadimilitello: "Sant’Agata di Militello", 
        capodorlando: "Capo D’Orlando", 
        gioiosamarea: "Gioiosa Marea", 
        brolo: "Brolo", 
        patti: "Patti", 
        barcellonapozzodigotto: "Barcellona Pozzo di Gotto", 
        portorosaport: "Portorosa Porto", 
        milazzoport: "Milazzo Porto", 
        milazzocenter: "Milazzo Centro", 
        messinaport: "Messina Porto", 
        messinacenter: "Messina Centro", 
        aliterme: "Ali Terme", 
        nizzadisicilia: "Nizza di Sicilia", 
        roccalumera: "Roccalumera", 
        furcisiculo: "Furci Siculo", 
        santateresa: "Santa Teresa", 
        savoca: "Savoca", 
        forzadagro: "Forza D’Agrò", 
        santalessio: "Sant’Alessio", 
        randazzo: "Randazzo", 
        bronte: "Bronte", 
        linguaglossa: "Linguaglossa città", 
        etnanord: "Etna nord (Linguaglossa)",
        etnasud: "Etna sud (Nicolosi)",
        santavenerina: "Santa Venerina", 
        zafferana: "Zafferana", 
        milo: "Milo", 
        solicchiata: "Solicchiata", 
        rovittello: "Rovittello", 
        piedimonteetneo: "Piedimonte Etneo",  
        fiumefreddodisicilia: "Fiumefreddo di Sicilia", 
        calatabiano: "Calatabiano", 
        mascali: "Mascali", 
        giarre: "Giarre", 
        acireale: "Acireale", 
        ripostoport: "Riposto porto", 
        ribera: "Ribera", 
        sciacca: "Sciacca", 
        mazaradelvallo: "Mazara del Vallo", 
        marsala: "Marsala",  
        trapanicenter: "Trapani Centro",
        trapaniport: "Trapani Porto",   
        trapaniairport: "Trapani Aeroporto",  
        sanvitolocapo: "San Vito lo Capo", 
        pozzallo: "Pozzallo",
        villasangiovanni: "Villa San Giovanni",
        reggiocalabriacity: "Reggio Calabrian città",
        reggiocalabriaairport: "Reggio Calabria aeroporto",
        lameziatermecity: "Lamezia Terme città",
        lameziatermeairport: "Lamezia Terme aeroporto" 
      }; 
  }else{
      namesLocations = {
        cataniaairport: "Catania Airport",
        cataniacenter: "Catania Center",
        cataniaport: "Catania Port",
        taormina: "Taormina",
        castelmola: "Castelmola",
        giardininaxos: "Giardini Naxos",
        letojanni: "Letojanni",
        siracusa: "Siracusa",
        augusta: "Augusta",
        brucoli: "Brucoli",
        noto: "Noto",
        fontanebianche: "Fontane Bianche",
        lidodinoto: "Lido di Noto",
        marzamemi: "Marzamemi", 
        ragusa: "Ragusa", 
        marinadiragusa: "Marina di Ragusa", 
        modica: "Modica", 
        marinadimodica: "Marina di Modica", 
        comisocenter: "Comiso Center",  
        comisoairport: "Comiso Airport", 
        vittoria: "Vittoria", 
        lentini: "Lentini", 
        carlentini: "Carlentini", 
        vizzini: "Vizzini", 
        francofonte: "Francofonte", 
        agrigento: "Agrigento", 
        gela: "Gela", 
        licata: "Licata", 
        caltagirone: "Caltagirone", 
        caltanissetta: "Caltanissetta", 
        enna: "Enna",  
        piazzaarmerina: "Piazza Armerina", 
        cefalu: "Cefalù", 
        palermocenter: "Palermo Center", 
        mondello: "Mondello", 
        palermoairport: "Palermo Airport", 
        bagheria: "Bagheria", 
        santaflavia: "Santa Flavia", 
        villabate: "Villabate", 
        campofelicediroccella: "Campo Felice di Roccella", 
        santagatadimilitello: "Sant’Agata di Militello", 
        capodorlando: "Capo D’Orlando", 
        gioiosamarea: "Gioiosa Marea", 
        brolo: "Brolo", 
        patti: "Patti", 
        barcellonapozzodigotto: "Barcellona Pozzo di Gotto", 
        portorosaport: "Portorosa Port", 
        milazzoport: "Milazzo Port", 
        milazzocenter: "Milazzo Center", 
        messinaport: "Messina Port", 
        messinacenter: "Messina Center", 
        aliterme: "Ali Terme", 
        nizzadisicilia: "Nizza di Sicilia", 
        roccalumera: "Roccalumera", 
        furcisiculo: "Furci Siculo", 
        santateresa: "Santa Teresa", 
        savoca: "Savoca", 
        forzadagro: "Forza D’Agrò", 
        santalessio: "Sant’Alessio", 
        randazzo: "Randazzo", 
        bronte: "Bronte", 
        linguaglossa: "Linguaglossa city", 
        etnanord: "Etna north side (Linguaglossa)",
        etnasud: "Etna south side (Nicolosi)",
        santavenerina: "Santa Venerina", 
        zafferana: "Zafferana", 
        milo: "Milo", 
        solicchiata: "Solicchiata", 
        rovittello: "Rovittello", 
        piedimonteetneo: "Piedimonte Etneo",  
        fiumefreddodisicilia: "Fiumefreddo di Sicilia", 
        calatabiano: "Calatabiano", 
        mascali: "Mascali", 
        giarre: "Giarre", 
        acireale: "Acireale", 
        ripostoport: "Riposto port", 
        ribera: "Ribera", 
        sciacca: "Sciacca", 
        mazaradelvallo: "Mazara del Vallo", 
        marsala: "Marsala",  
        trapanicenter: "Trapani Center",  
        trapaniport: "Trapani Port", 
        trapaniairport: "Trapani Airport",  
        sanvitolocapo: "San Vito lo Capo", 
        pozzallo: "Pozzallo", 
        villasangiovanni: "Villa San Giovanni",
        reggiocalabriacity: "Reggio Calabrian city",
        reggiocalabriaairport: "Reggio Calabria airport",
        lameziatermecity: "Lamezia Terme city",
        lameziatermeairport: "Lamezia Terme airport"
      }; 
  }
}

// Updated 19.09.2026
var pricesTaormina = {
  top: [
   "cataniaairport",
   "cataniacenter",
   "messinacenter",
   "messinaport",
   "milazzocenter", 
   "milazzoport", 
   "portorosaport", 
   "siracusa"
  ], 
  cataniaairport: [120, 120, 130, 140, 150, 160, 180, 200],
  cataniacenter: [120, 120, 130, 140, 150, 160, 180, 200],
  cataniaport: [120, 120, 130, 140, 150, 160, 180, 200],

  siracusa: [220, 220, 220, 250, 270, 280, 290, 300],
  augusta: [160, 160, 180, 200, 220, 240, 260, 280],
  brucoli: [160, 160, 180, 200, 220, 240, 260, 280],
  noto: [260, 260, 280, 290, 300, 320, 340, 360],
  fontanebianche: [280, 280, 300, 350, 360, 370, 400, 420],
  lidodinoto: [260, 260, 280, 290, 300, 320, 340, 360],
  marzamemi: [320, 320, 340, 360, 380, 380, 400, 420],
  ragusa: [300, 300, 320, 340, 360, 380, 390, 400],
  marinadiragusa: [350, 350, 360, 380, 400, 420, 440, 450],
  modica: [330, 330, 340, 360, 380, 400, 420, 430],
  marinadimodica: [350, 350, 360, 380, 400, 420, 440, 450],
  comisocenter: [350, 350, 350, 370, 390, 400, 420, 460],
  comisoairport: [350, 350, 350, 370, 390, 400, 420, 460],
  vittoria: [320, 320, 330, 360, 380, 390, 400, 420],

  lentini: [180, 180, 200, 220, 240, 250, 260, 300],
  carlentini: [180, 180, 200, 220, 240, 250, 260, 300],
  vizzini: [230, 230, 250, 270, 290, 300, 330, 350],
  francofonte: [200, 200, 220, 240, 260, 280, 290, 300],

  agrigento: [385, 385, 400, 420, 450, 480, 500, 530],
  gela: [350, 350, 360, 380, 400, 420, 440, 450],
  licata: [330, 330, 340, 360, 380, 400, 420, 430],
  caltagirone: [300, 300, 320, 340, 360, 380, 390, 400],
  caltanissetta: [300, 300, 320, 340, 360, 380, 390, 400],
  enna: [300, 300, 320, 340, 360, 380, 390, 400],
  piazzaarmerina: [350, 350, 370, 380, 400, 420, 460, 480],

  cefalu: [500, 500, 550, 600, 650, 670, 700, 750],
  palermocenter: [700, 700, 700, 750, 800, 850, 850, 900],
  mondello: [500, 550, 600, 650, 700, 750, 800, 850],
  palermoairport: [700, 700, 700, 750, 800, 850, 850, 900],
  bagheria: [400, 400, 420, 450, 470, 490, 500, 550],
  santaflavia: [400, 400, 420, 450, 470, 490, 500, 550],
  villabate: [430, 430, 450, 460, 470, 490, 500, 550],
  campofelicediroccella: [385, 385, 400, 420, 430, 440, 450, 460],

  santagatadimilitello: [380, 380, 390, 400, 420, 430, 440, 460],
  capodorlando: [330, 330, 350, 370, 390, 400, 420, 450],
  gioiosamarea: [300, 300, 330, 350, 370, 390, 420, 450],
  brolo: [300, 300, 330, 350, 370, 390, 420, 450],
  patti: [230, 230, 240, 250, 260, 270, 280, 290],

  barcellonapozzodigotto: [180, 180, 200, 220, 230, 250, 280, 290],
  portorosaport: [230, 230, 250, 280, 300, 330, 370, 400],
  milazzoport: [180, 180, 190, 200, 220, 250, 280, 330],
  milazzocenter: [180, 180, 190, 200, 220, 250, 280, 330],
  messinaport: [130, 130, 140, 160, 180, 200, 250, 280],
  messinacenter: [130, 130, 140, 160, 180, 200, 250, 280],

  aliterme: [110, 120, 130, 150, 160, 180, 190, 220],
  nizzadisicilia: [100, 100, 110, 120, 130, 140, 160, 180],
  roccalumera: [90, 90, 100, 120, 130, 140, 150, 160],
  furcisiculo: [90, 90, 100, 120, 130, 140, 150, 160],
  santateresa: [80, 80, 90, 100, 110, 120, 130, 140],
  savoca: [110, 120, 130, 150, 160, 180, 190, 220],
  forzadagro: [110, 120, 130, 150, 160, 180, 190, 220],
  santalessio: [80, 80, 90, 100, 110, 120, 130, 140],

  randazzo: [130, 130, 150, 160, 170, 180, 190, 200],
  bronte: [150, 150, 160, 180, 190, 200, 220, 240],
  linguaglossa: [100, 100, 120, 130, 140, 150, 160, 170],
  etnanord:[200, 200, 200, 250, 250, 270, 290, 350],
  etnasud:[200, 200, 200, 250, 250, 270, 290, 350],
  santavenerina: [80, 80, 90, 100, 110, 120, 130, 140],
  zafferana: [90, 90, 100, 120, 130, 140, 150, 160],
  milo: [110, 120, 130, 150, 160, 180, 190, 220],
  solicchiata: [120, 120, 130, 140, 150, 160, 170, 180],
  rovittello: [120, 120, 130, 140, 150, 160, 170, 180],
  piedimonteetneo: [80, 80, 90, 100, 110, 120, 130, 140],

  fiumefreddodisicilia: [50, 50, 60, 70, 80, 90, 100, 110],
  calatabiano: [45, 45, 60, 70, 80, 90, 100, 110],
  mascali: [60, 60, 70, 80, 90, 110, 130, 150],
  giarre: [90, 90, 100, 110, 120, 130, 140, 150],
  acireale: [90, 90, 100, 110, 120, 130, 140, 150],
  ripostoport: [120, 120, 140, 160, 180, 220, 250, 300],

  ribera: [400, 400, 420, 430, 450, 480, 500, 550],
  sciacca: [430, 430, 450, 470, 480, 500, 530, 580],
  mazaradelvallo: [550, 550, 560, 580, 600, 620, 650, 680],
  marsala: [700, 700, 700, 750, 800, 850, 850, 900],
  trapanicenter: [700, 700, 700, 750, 800, 850, 850, 900],
  trapaniport: [700, 700, 700, 750, 800, 850, 850, 900],
  trapaniairport: [800, 800, 800, 800, 850, 870, 900, 950],
  sanvitolocapo: [900, 900, 900, 900, 930, 950, 980, 990],
  pozzallo: [300, 300, 320, 340, 360, 380, 400, 440],

  villasangiovanni: [350, 350, 370, 400, 430, 450, 500, 550],
  reggiocalabriacity: [400, 400, 420, 450, 470, 500, 550, 600],
  reggiocalabriaairport: [400, 400, 420, 450, 470, 500, 550, 600],
  lameziatermecity: [800, 800, 850, 900, 950, 1000, 1100, 1200],
  lameziatermeairport: [800, 800, 850, 900, 950, 1000, 1100, 1200]
};

// Updated 19.09.2026
var pricesCataniaAirport = {
  top: [
    "taormina",
    "giardininaxos",
    "letojanni",
    "forzadagro",
    "messinacenter",
    "messinaport",
    "milazzocenter",
    "milazzoport",
    "portorosaport",
    "siracusa",
    "ripostoport",
    "cefalu"
  ],
  taormina: [120, 120, 130, 140, 150, 160, 180, 200],
  giardininaxos: [120, 120, 130, 140, 150, 160, 180, 200],
  letojanni: [120, 120, 130, 140, 150, 160, 180, 200],
  castelmola: [150, 150, 150, 160, 160, 170, 180, 200],
  siracusa: [120, 130, 140, 150, 160, 170, 180, 200],
  augusta: [120, 120, 130, 140, 150, 160, 170, 180],
  brucoli: [120, 120, 130, 140, 150, 160, 170, 180],
  noto: [200, 200, 220, 240, 260, 270, 280, 300],
  fontanebianche: [200, 200, 220, 230, 250, 270, 290, 320],
  lidodinoto: [230, 230, 240, 250, 260, 270, 280, 290],
  marzamemi: [280, 280, 290, 300, 320, 340, 360, 380],
  ragusa: [250, 250, 260, 280, 300, 320, 340, 360],
  marinadiragusa: [280, 280, 300, 320, 340, 360, 380, 390],
  modica: [260, 260, 270, 280, 290, 300, 320, 340],
  marinadimodica: [280, 280, 300, 320, 340, 360, 380, 390],
  comisocenter: [250, 250, 260, 280, 300, 320, 340, 360],
  comisoairport: [250, 250, 260, 280, 300, 320, 340, 360],
  vittoria: [270, 270, 280, 300, 320, 340, 360, 380],
  lentini: [120, 120, 130, 150, 170, 180, 190, 200],
  carlentini: [140, 140, 150, 160, 180, 190, 200, 220],
  vizzini: [200, 200, 220, 230, 240, 250, 260, 280],
  francofonte: [160, 160, 170, 180, 200, 220, 240, 260],
  agrigento: [350, 350, 370, 380, 400, 420, 450, 480],
  gela: [300, 300, 330, 340, 360, 380, 400, 420],
  licata: [335, 335, 340, 350, 360, 380, 390, 400],
  caltagirone: [275, 275, 280, 290, 300, 310, 320, 330],
  caltanissetta: [280, 280, 300, 310, 330, 350, 360, 380],
  enna: [280, 280, 290, 300, 320, 330, 350, 370],
  piazzaarmerina: [300, 300, 320, 340, 350, 370, 380, 400],
  cefalu: [350, 350, 360, 370, 390, 400, 420, 440],
  palermocenter: [500, 500, 500, 600, 600, 700, 750, 800],
  mondello: [450, 450, 460, 470, 480, 500, 520, 540],
  palermoairport: [500, 500, 500, 600, 600, 700, 750, 800],
  bagheria: [380, 380, 390, 400, 410, 420, 430, 450],
  santaflavia: [380, 380, 390, 400, 410, 420, 430, 450],
  villabate: [380, 380, 390, 400, 410, 420, 430, 450],
  campofelicediroccella: [300, 300, 330, 340, 360, 380, 400, 420],
  santagatadimilitello: [450, 450, 485, 520, 550, 600, 650, 700],
  capodorlando: [420, 420, 450, 480, 550, 590, 620, 650],
  gioiosamarea: [330, 330, 350, 380, 410, 440, 470, 520],
  brolo: [350, 350, 380, 400, 420, 450, 480, 550],
  patti: [280, 280, 300, 320, 350, 380, 410, 440],
  barcellonapozzodigotto: [230, 230, 250, 270, 290, 320, 350, 380],
  portorosaport: [300, 300, 300, 330, 350, 400, 450, 500],
  milazzoport: [250, 250, 250, 250, 270, 280, 300, 330],
  milazzocenter: [250, 250, 250, 250, 270, 280, 300, 330],
  messinaport: [170, 170, 180, 200, 230, 250, 270, 300],
  messinacenter: [170, 170, 180, 200, 230, 250, 270, 300],
  aliterme: [160, 160, 180, 190, 210, 220, 240, 270],
  nizzadisicilia: [160, 160, 180, 190, 210, 220, 240, 270],
  roccalumera: [150, 150, 170, 180, 190, 200, 220, 250],
  furcisiculo: [150, 150, 170, 180, 190, 200, 220, 250],
  santateresa: [150, 150, 170, 180, 190, 200, 220, 250],
  savoca: [170, 170, 190, 200, 220, 240, 260, 280],
  forzadagro: [150, 150, 170, 180, 190, 200, 220, 250],
  santalessio: [150, 150, 170, 180, 190, 200, 220, 250],
  randazzo: [200, 200, 220, 230, 240, 250, 280, 300],
  bronte: [220, 220, 240, 250, 260, 270, 290, 330],
  linguaglossa: [170, 170, 190, 200, 220, 240, 260, 280],
  santavenerina: [150, 150, 170, 180, 190, 200, 220, 240],
  zafferana: [160, 160, 180, 190, 200, 210, 230, 260],
  milo: [170, 170, 190, 200, 220, 240, 260, 280],
  solicchiata: [180, 180, 200, 220, 230, 250, 270, 300],
  rovittello: [180, 180, 200, 220, 230, 250, 270, 300],
  piedimonteetneo: [150, 150, 170, 180, 190, 200, 220, 250],
  fiumefreddodisicilia: [90, 90, 100, 110, 120, 140, 150, 170],
  calatabiano: [90, 90, 100, 110, 120, 140, 150, 170],
  mascali: [100, 100, 110, 120, 130, 150, 170, 180],
  giarre: [100, 100, 110, 120, 130, 150, 170, 180],
  acireale: [90, 90, 100, 110, 120, 140, 150, 170],
  ripostoport: [150, 150, 170, 180, 220, 250, 280, 330],
  ribera: [380, 380, 400, 420, 440, 460, 480, 500],
  sciacca: [400, 400, 420, 440, 460, 480, 500, 520],
  mazaradelvallo: [600, 600, 650, 700, 750, 780, 800, 850],
  marsala: [600, 600, 650, 700, 750, 780, 800, 850],
  trapanicenter: [600, 600, 650, 700, 750, 780, 800, 850],
  trapaniairport: [600, 600, 650, 700, 750, 780, 800, 850],
  sanvitolocapo: [650, 650, 680, 720, 750, 800, 850, 900],
  pozzallo: [250, 250, 270, 290, 310, 330, 360, 390],
  villasangiovanni: [400, 400, 450, 500, 530, 550, 600, 650],
  reggiocalabriacity: [450, 450, 470, 500, 520, 530, 570, 650],
  reggiocalabriaairport: [450, 450, 470, 500, 520, 530, 570, 650],
  lameziatermecity: [850, 850, 850, 900, 950, 1100, 1150, 1250],
  lameziatermeairport: [850, 850, 850, 900, 950, 1100, 1150, 1250]
};

// Updated 10.01.2026
var pricesCastelmola = {
  top: [
    "cataniaairport",
    "cataniacenter",
    "messinacenter",
    "messinaport",
    "milazzocenter", 
    "milazzoport", 
    "portorosaport", 
    "siracusa"
  ],
  cataniaairport: [150, 150, 150, 160, 160, 170, 180, 200],
  cataniacenter: [150, 150, 150, 160, 160, 170, 180, 200],
  cataniaport: [150, 150, 150, 160, 160, 170, 180, 200],
  siracusa: [190, 190, 200, 220, 240, 260, 280, 300],
  augusta: [160, 160, 180, 200, 220, 240, 260, 280],
  brucoli: [160, 160, 180, 200, 220, 240, 260, 280],
  noto: [260, 260, 280, 290, 300, 320, 340, 360],
  fontanebianche: [300, 300, 320, 330, 380, 400, 420, 450],
  lidodinoto: [260, 260, 280, 290, 300, 320, 340, 360],
  marzamemi: [320, 320, 340, 360, 380, 380, 400, 420],
  ragusa: [300, 300, 320, 340, 360, 380, 390, 400],
  marinadiragusa: [350, 350, 360, 380, 400, 420, 440, 450],
  modica: [330, 330, 340, 360, 380, 400, 420, 430],
  marinadimodica: [350, 350, 360, 380, 400, 420, 440, 450],
  comisocenter: [300, 300, 320, 340, 360, 380, 390, 400],
  comisoairport: [300, 300, 320, 340, 360, 380, 390, 400],
  vittoria: [320, 320, 330, 360, 380, 390, 400, 420],
  lentini: [180, 180, 200, 220, 240, 250, 260, 300],
  carlentini: [180, 180, 200, 220, 240, 250, 260, 300],
  vizzini: [230, 230, 250, 270, 290, 300, 330, 350],
  francofonte: [200, 200, 220, 240, 260, 280, 290, 300],
  agrigento: [385, 385, 400, 420, 450, 480, 500, 530],
  gela: [350, 350, 360, 380, 400, 420, 440, 450],
  licata: [330, 330, 340, 360, 380, 400, 420, 430],
  caltagirone: [300, 300, 320, 340, 360, 380, 390, 400],
  caltanissetta: [300, 300, 320, 340, 360, 380, 390, 400],
  enna: [300, 300, 320, 340, 360, 380, 390, 400],
  piazzaarmerina: [350, 350, 370, 380, 400, 420, 460, 480],
  cefalu: [400, 400, 420, 450, 470, 490, 500, 550],
  palermocenter: [530, 530, 550, 580, 600, 630, 650, 680],
  mondello: [500, 550, 600, 650, 700, 750, 800, 850],
  palermoairport: [550, 550, 560, 600, 600, 630, 650, 680],
  bagheria: [400, 400, 420, 450, 470, 490, 500, 550],
  santaflavia: [400, 400, 420, 450, 470, 490, 500, 550],
  villabate: [430, 430, 450, 460, 470, 490, 500, 550],
  campofelicediroccella: [385, 385, 400, 420, 430, 440, 450, 460],
  santagatadimilitello: [380, 380, 390, 400, 420, 430, 440, 460],
  capodorlando: [330, 330, 350, 370, 390, 400, 420, 450],
  gioiosamarea: [300, 300, 330, 350, 370, 390, 420, 450],
  brolo: [300, 300, 330, 350, 370, 390, 420, 450],
  patti: [230, 230, 240, 250, 260, 270, 280, 290],
  barcellonapozzodigotto: [180, 180, 200, 220, 230, 250, 280, 290],
  portorosaport: [200, 200, 220, 240, 260, 280, 300, 340],
  milazzoport: [190, 190, 200, 220, 230, 240, 260, 280],
  milazzocenter: [190, 190, 200, 220, 230, 240, 260, 280],
  messinaport: [160, 160, 180, 200, 210, 230, 250, 280],
  messinacenter: [160, 160, 180, 200, 210, 230, 250, 280],
  aliterme: [120, 120, 130, 150, 160, 180, 190, 220],
  nizzadisicilia: [100, 100, 110, 120, 130, 140, 160, 180],
  roccalumera: [100, 100, 110, 120, 130, 140, 160, 180],
  furcisiculo: [100, 100, 110, 120, 130, 140, 160, 180],
  santateresa: [100, 100, 110, 120, 130, 140, 160, 180],
  savoca: [110, 120, 130, 150, 160, 180, 190, 220],
  forzadagro: [110, 120, 130, 150, 160, 180, 190, 220],
  santalessio: [90, 90, 100, 120, 130, 140, 150, 160],
  randazzo: [150, 150, 170, 180, 190, 200, 200, 240],
  bronte: [180, 180, 200, 220, 240, 250, 260, 300],
  linguaglossa: [100, 100, 120, 130, 140, 150, 160, 170],
  santavenerina: [100, 100, 120, 130, 140, 150, 160, 170],
  zafferana: [110, 120, 130, 150, 160, 180, 190, 220],
  milo: [120, 120, 130, 140, 150, 160, 170, 180],
  solicchiata: [130, 130, 150, 160, 170, 180, 190, 220],
  rovittello: [130, 130, 150, 160, 170, 180, 190, 220],
  piedimonteetneo: [90, 90, 100, 110, 120, 130, 140, 150],
  fiumefreddodisicilia: [60, 60, 70, 80, 90, 110, 130, 150],
  calatabiano: [70, 70, 80, 100, 120, 140, 160, 180],
  mascali: [80, 80, 100, 110, 120, 130, 150, 170],
  giarre: [100, 100, 120, 140, 160, 180, 200, 220],
  acireale: [110, 120, 130, 150, 160, 180, 190, 220],
  ripostoport: [100, 100, 120, 140, 160, 180, 200, 220],
  ribera: [400, 400, 420, 430, 450, 480, 500, 550],
  sciacca: [430, 430, 450, 470, 480, 500, 530, 580],
  mazaradelvallo: [550, 550, 560, 580, 600, 620, 650, 680],
  marsala: [550, 550, 560, 580, 600, 620, 650, 680],
  trapanicenter: [800, 800, 800, 800, 850, 870, 900, 950],
  trapaniairport: [800, 800, 800, 800, 850, 870, 900, 950],
  sanvitolocapo: [900, 900, 900, 900, 930, 950, 980, 990],
  pozzallo: [300, 300, 320, 340, 360, 380, 400, 440],
};

// Updated 10.01.2026
var pricesSiracusa = {
  top: [
    "cataniaairport",
    "cataniacenter",
    "taormina",
    "giardininaxos",
    "letojanni",
    "forzadagro",
    "messinacenter",
    "messinaport",
  ],
  cataniaairport: [120, 130, 140, 150, 160, 170, 180, 200],
  cataniacenter: [120, 130, 140, 150, 160, 170, 180, 200],
  cataniaport: [120, 130, 140, 150, 160, 170, 180, 200],
  taormina: [220, 220, 220, 250, 270, 280, 290, 300],
  giardininaxos: [220, 220, 220, 250, 270, 280, 290, 300],
  letojanni: [220, 220, 220, 250, 270, 280, 290, 300],
  castelmola: [190, 190, 200, 220, 240, 260, 280, 300],
  cefalu: [400, 400, 420, 450, 470, 490, 500, 550],
  palermocenter: [530, 530, 550, 580, 600, 630, 650, 680],
  mondello: [500, 550, 600, 650, 700, 750, 800, 850],
  palermoairport: [550, 550, 560, 600, 600, 630, 650, 680],
  bagheria: [400, 400, 420, 450, 470, 490, 500, 550],
  santaflavia: [400, 400, 420, 450, 470, 490, 500, 550],
  villabate: [430, 430, 450, 460, 470, 490, 500, 550],
  campofelicediroccella: [385, 385, 400, 420, 430, 440, 450, 460],
  santagatadimilitello: [500, 500, 530, 550, 580, 620, 650, 700],
  capodorlando: [470, 470, 480, 500, 530, 550, 570, 600],
  gioiosamarea: [380, 380, 400, 420, 430, 450, 470, 500],
  brolo: [380, 380, 400, 420, 430, 450, 470, 500],
  patti: [370, 350, 370, 380, 400, 420, 440, 460],
  barcellonapozzodigotto: [300, 300, 320, 340, 360, 380, 400, 420],
  portorosaport: [330, 330, 350, 370, 390, 400, 440, 470],
  milazzoport: [290, 290, 300, 330, 350, 370, 390, 440],
  milazzocenter: [290, 290, 300, 330, 350, 370, 390, 440],
  messinaport: [270, 270, 290, 320, 340, 360, 380, 400],
  messinacenter: [270, 270, 290, 320, 340, 360, 380, 400],
  roccalumera: [250, 250, 270, 290, 300, 330, 350, 370],
  furcisiculo: [240, 240, 260, 280, 290, 320, 340, 360],
  santateresa: [240, 240, 260, 280, 290, 320, 340, 360],
  savoca: [260, 260, 280, 290, 300, 330, 350, 380],
  forzadagro: [260, 260, 280, 290, 300, 330, 350, 380],
  santalessio: [240, 240, 260, 280, 290, 310, 330, 350],
  randazzo: [370, 350, 370, 380, 400, 420, 440, 460],
  bronte: [380, 380, 400, 420, 430, 450, 470, 500],
  linguaglossa: [350, 350, 370, 380, 400, 420, 460, 480],
  santavenerina: [300, 300, 320, 340, 360, 380, 390, 400],
  zafferana: [340, 340, 360, 370, 390, 400, 440, 460],
  milo: [350, 350, 370, 380, 400, 420, 460, 480],
  solicchiata: [340, 340, 360, 370, 390, 400, 440, 460],
  rovittello: [340, 340, 360, 370, 390, 400, 440, 460],
  piedimonteetneo: [330, 330, 350, 370, 390, 400, 440, 470],
  fiumefreddodisicilia: [170, 170, 190, 200, 220, 240, 260, 280],
  calatabiano: [170, 170, 190, 200, 220, 240, 260, 280],
  mascali: [160, 160, 180, 190, 200, 220, 240, 260],
  giarre: [170, 170, 190, 200, 220, 240, 260, 280],
  acireale: [160, 160, 180, 190, 200, 220, 240, 260],
  ripostoport: [200, 200, 220, 240, 250, 270, 290, 320],
};

// Updated 19.09.2026
var pricesMessina = {
  top: [
   "cataniaairport",
   "cataniacenter",
   "taormina",
   "giardininaxos",
   "letojanni", 
   "siracusa"
  ], 
  cataniaairport: [170, 170, 180, 200, 230, 250, 270, 300],
  cataniacenter: [170, 170, 180, 200, 230, 250, 270, 300],
  cataniaport: [170, 170, 180, 200, 230, 250, 270, 300],
  taormina: [130, 130, 140, 160, 180, 200, 250, 280],
  giardininaxos: [130, 130, 140, 160, 180, 200, 250, 280],
  letojanni: [130, 130, 140, 160, 180, 200, 250, 280],
  castelmola: [160, 160, 180, 200, 210, 230, 250, 280],
  siracusa: [270, 270, 290, 320, 340, 360, 380, 400],
  augusta: [250, 250, 260, 280, 300, 320, 340, 360],
  brucoli: [250, 250, 260, 280, 300, 320, 340, 360],
  noto: [330, 330, 350, 370, 390, 400, 440, 470],
  fontanebianche: [380, 380, 400, 450, 460, 470, 500, 550],
  lidodinoto: [330, 330, 350, 370, 390, 400, 440, 470],
  marzamemi: [380, 380, 400, 420, 430, 450, 470, 500],
  ragusa: [380, 380, 400, 420, 430, 450, 470, 500],
  marinadiragusa: [430, 430, 450, 470, 480, 500, 530, 580],
  modica: [420, 420, 450, 480, 550, 590, 620, 650],
  marinadimodica: [430, 430, 450, 470, 480, 500, 530, 580],
  comisocenter: [380, 380, 400, 420, 430, 450, 470, 500],
  comisoairport: [380, 380, 400, 420, 430, 450, 470, 500],
  vittoria: [400, 400, 420, 450, 470, 490, 500, 550],
  lentini: [300, 300, 320, 340, 360, 380, 400, 420],
  carlentini: [300, 300, 320, 340, 360, 380, 400, 420],
  vizzini: [330, 330, 350, 370, 390, 400, 440, 470],
  francofonte: [280, 280, 300, 310, 330, 350, 360, 380],
  agrigento: [550, 550, 560, 600, 600, 630, 650, 680],
  gela: [500, 550, 600, 650, 700, 750, 800, 850],
  licata: [550, 550, 560, 580, 600, 620, 650, 680],
  caltagirone: [430, 430, 450, 470, 480, 500, 530, 580],
  caltanissetta: [430, 430, 450, 470, 480, 500, 530, 580],
  enna: [450, 450, 460, 470, 480, 500, 520, 540],
  piazzaarmerina: [450, 450, 460, 470, 480, 500, 520, 540],
  cefalu: [380, 380, 400, 420, 430, 450, 470, 500],
  palermocenter: [450, 450, 460, 470, 480, 500, 520, 540],
  mondello: [470, 470, 490, 500, 520, 540, 560, 580],
  palermoairport: [550, 550, 580, 600, 620, 640, 660, 680],
  bagheria: [430, 430, 450, 470, 480, 500, 530, 580],
  santaflavia: [430, 430, 450, 470, 480, 500, 530, 580],
  villabate: [400, 400, 420, 440, 460, 480, 500, 520],
  campofelicediroccella: [380, 380, 400, 420, 430, 450, 470, 500],
  roccalumera: [90, 90, 100, 110, 120, 130, 140, 160],
  furcisiculo: [90, 90, 100, 110, 120, 130, 140, 160],
  santateresa: [80, 80, 90, 100, 110, 120, 130, 150],
  savoca: [120, 120, 130, 140, 150, 160, 170, 190],
  forzadagro: [120, 120, 130, 140, 150, 160, 170, 190],
  santalessio: [90, 90, 100, 110, 120, 130, 140, 160],
  randazzo: [300, 300, 320, 340, 360, 380, 400, 420],
  bronte: [330, 330, 350, 370, 390, 400, 440, 470],
  linguaglossa: [280, 280, 300, 320, 350, 380, 410, 440],
  santavenerina: [200, 200, 220, 230, 250, 270, 290, 320],
  zafferana: [220, 220, 230, 240, 260, 280, 300, 340],
  milo: [280, 280, 300, 320, 350, 380, 410, 440],
  solicchiata: [270, 270, 280, 300, 330, 350, 380, 400],
  rovittello: [270, 270, 280, 300, 330, 350, 380, 400],
  piedimonteetneo: [200, 200, 220, 230, 250, 270, 290, 320],
  fiumefreddodisicilia: [130, 150, 160, 170, 180, 200, 220, 250],
  calatabiano: [130, 150, 160, 170, 180, 200, 220, 250],
  mascali: [140, 140, 150, 160, 180, 190, 200, 220],
  giarre: [150, 150, 160, 170, 190, 200, 220, 240],
  acireale: [160, 160, 180, 200, 210, 230, 250, 280],
  ripostoport: [160, 160, 180, 200, 210, 230, 250, 280],
  ribera: [580, 580, 600, 620, 640, 660, 680, 700],
  sciacca: [600, 600, 620, 640, 660, 680, 700, 720],
  mazaradelvallo: [800, 800, 830, 850, 880, 900, 950, 990],
  marsala: [800, 800, 830, 850, 880, 900, 950, 990],
  trapanicenter: [800, 800, 830, 850, 880, 900, 950, 990],
  trapaniairport: [800, 800, 830, 850, 880, 900, 950, 990],
  sanvitolocapo: [900, 900, 930, 950, 980, 990, 990, 990],
  pozzallo: [400, 400, 420, 440, 460, 480, 500, 520],
};


// Updated 19.09.2026
var pricesMilazzo = {
  top: [
   "cataniaairport",
   "cataniacenter",
   "taormina",
   "giardininaxos",
   "letojanni",
   "siracusa"
  ],
  cataniaairport: [250, 250, 250, 250, 270, 280, 300, 330],
  cataniacenter: [250, 250, 250, 250, 270, 280, 300, 330],
  cataniaport: [250, 250, 250, 250, 270, 280, 300, 330],
  taormina: [180, 180, 190, 200, 220, 250, 280, 330],
  giardininaxos: [180, 180, 190, 200, 220, 250, 280, 330],
  letojanni: [180, 180, 190, 200, 220, 250, 280, 330],
  castelmola: [190, 190, 200, 220, 230, 240, 260, 280],
  siracusa: [290, 290, 300, 330, 350, 370, 390, 440],
  augusta: [250, 250, 260, 280, 300, 320, 340, 360],
  brucoli: [250, 250, 260, 280, 300, 320, 340, 360],
  noto: [370, 350, 370, 380, 400, 420, 440, 460],
  fontanebianche: [450, 450, 470, 490, 530, 560, 600, 650],
  lidodinoto: [370, 350, 370, 380, 400, 420, 440, 460],
  marzamemi: [450, 450, 460, 470, 480, 500, 520, 540],
  ragusa: [430, 430, 450, 460, 470, 490, 500, 550],
  marinadiragusa: [480, 480, 490, 500, 520, 540, 560, 600],
  modica: [450, 450, 460, 470, 480, 500, 520, 540],
  marinadimodica: [480, 480, 490, 500, 520, 540, 560, 600],
  comisocenter: [400, 400, 420, 440, 460, 480, 500, 520],
  comisoairport: [400, 400, 420, 440, 460, 480, 500, 520],
  vittoria: [420, 420, 450, 480, 550, 590, 620, 650],
  lentini: [330, 330, 350, 370, 390, 400, 440, 470],
  carlentini: [330, 330, 350, 370, 390, 400, 440, 470],
  vizzini: [380, 380, 400, 420, 430, 450, 470, 500],
  francofonte: [350, 350, 370, 380, 400, 420, 460, 480],
  agrigento: [580, 580, 600, 620, 640, 660, 680, 700],
  gela: [550, 550, 580, 600, 620, 640, 660, 680],
  licata: [600, 600, 620, 640, 660, 680, 700, 720],
  caltagirone: [480, 480, 500, 520, 540, 560, 580, 600],
  caltanissetta: [480, 480, 500, 520, 540, 560, 580, 600],
  enna: [480, 480, 500, 520, 540, 560, 580, 600],
  piazzaarmerina: [500, 550, 600, 650, 700, 750, 800, 850],
  cefalu: [400, 400, 420, 440, 460, 480, 500, 520],
  palermocenter: [550, 550, 580, 600, 620, 640, 660, 680],
  mondello: [580, 580, 600, 620, 640, 660, 680, 700],
  palermoairport: [600, 600, 620, 640, 660, 680, 700, 720],
  bagheria: [400, 400, 420, 440, 460, 480, 500, 520],
  santaflavia: [400, 400, 420, 440, 460, 480, 500, 520],
  villabate: [430, 430, 450, 470, 480, 500, 530, 580],
  campofelicediroccella: [400, 400, 420, 440, 460, 480, 500, 520],
  roccalumera: [130, 150, 160, 170, 180, 200, 220, 250],
  furcisiculo: [130, 150, 160, 170, 180, 200, 220, 250],
  santateresa: [120, 120, 130, 140, 150, 160, 170, 190],
  savoca: [150, 150, 160, 170, 190, 200, 220, 240],
  forzadagro: [150, 150, 160, 170, 190, 200, 220, 240],
  santalessio: [120, 120, 130, 140, 150, 160, 170, 190],
  randazzo: [330, 330, 350, 370, 390, 400, 440, 470],
  bronte: [350, 350, 370, 380, 400, 420, 460, 480],
  linguaglossa: [280, 280, 300, 310, 330, 350, 360, 380],
  santavenerina: [250, 250, 260, 280, 300, 320, 340, 360],
  zafferana: [280, 280, 300, 310, 330, 350, 360, 380],
  milo: [330, 330, 350, 370, 390, 400, 440, 470],
  solicchiata: [300, 300, 320, 340, 360, 380, 390, 400],
  rovittello: [300, 300, 320, 340, 360, 380, 390, 400],
  piedimonteetneo: [250, 250, 260, 280, 300, 320, 340, 360],
  fiumefreddodisicilia: [170, 170, 190, 200, 220, 240, 260, 280],
  calatabiano: [170, 170, 190, 200, 220, 240, 260, 280],
  mascali: [180, 180, 200, 220, 240, 250, 260, 300],
  giarre: [190, 190, 200, 220, 240, 260, 280, 300],
  acireale: [200, 200, 220, 230, 250, 270, 290, 320],
  ripostoport: [250, 250, 260, 280, 300, 320, 340, 360],
  ribera: [600, 600, 620, 640, 660, 680, 700, 720],
  sciacca: [630, 630, 650, 670, 690, 710, 730, 750],
  mazaradelvallo: [800, 800, 830, 850, 880, 900, 950, 990],
  marsala: [800, 800, 830, 850, 880, 900, 950, 990],
  trapanicenter: [800, 800, 830, 850, 880, 900, 950, 990],
  trapaniairport: [800, 800, 830, 850, 880, 900, 950, 990],
  sanvitolocapo: [900, 900, 930, 950, 980, 990, 990, 990],
  pozzallo: [450, 450, 460, 470, 480, 500, 520, 540],

};


// Updated 10.01.2026
var pricesComiso = {
  top: [
   "cataniaairport",
   "cataniacenter",
   "taormina",
   "giardininaxos",
   "letojanni", 
   "siracusa",
   "messinacenter",
   "messinaport",
   "milazzocenter", 
   "milazzoport", 
   "portorosaport", 
  ], 
  cataniaairport: [250, 250, 260, 280, 300, 320, 340, 360],
  cataniacenter: [250, 250, 260, 280, 300, 320, 340, 360],
  cataniaport: [250, 250, 260, 280, 300, 320, 340, 360],
  taormina: [350, 350, 350, 370, 390, 400, 420, 460],
  giardininaxos: [350, 350, 350, 370, 390, 400, 420, 460],
  letojanni: [350, 350, 350, 370, 390, 400, 420, 460],
  castelmola: [300, 300, 320, 340, 360, 380, 390, 400],
  cefalu: [650, 650, 670, 690, 710, 730, 750, 780],
  palermocenter: [700, 700, 720, 740, 760, 780, 800, 820],
  mondello: [720, 720, 740, 760, 780, 800, 820, 840],
  palermoairport: [750, 750, 770, 780, 800, 820, 840, 860],
  bagheria: [650, 650, 670, 690, 710, 730, 750, 780],
  santaflavia: [650, 650, 670, 690, 710, 730, 750, 780],
  villabate: [670, 670, 680, 700, 720, 740, 770, 800],
  campofelicediroccella: [600, 600, 620, 640, 660, 680, 700, 720],
  santagatadimilitello: [700, 700, 720, 750, 780, 800, 820, 850],
  capodorlando: [650, 650, 670, 690, 710, 730, 750, 780],
  gioiosamarea: [600, 600, 620, 640, 660, 680, 700, 720],
  brolo: [580, 580, 600, 620, 640, 660, 680, 700],
  patti: [550, 550, 580, 600, 620, 640, 660, 680],
  barcellonapozzodigotto: [420, 420, 450, 480, 550, 590, 620, 650],
  portorosaport: [480, 480, 490, 500, 520, 540, 560, 600],
  milazzoport: [400, 400, 420, 440, 460, 480, 500, 520],
  milazzocenter: [400, 400, 420, 440, 460, 480, 500, 520],
  messinaport: [380, 380, 400, 420, 430, 450, 470, 500],
  messinacenter: [380, 380, 400, 420, 430, 450, 470, 500],
  roccalumera: [360, 360, 370, 390, 400, 420, 440, 460],
  furcisiculo: [360, 360, 370, 390, 400, 420, 440, 460],
  santateresa: [350, 350, 370, 380, 400, 420, 460, 480],
  savoca: [400, 400, 420, 440, 460, 480, 500, 520],
  forzadagro: [380, 380, 400, 420, 430, 450, 470, 500],
  santalessio: [340, 340, 350, 360, 380, 400, 420, 440],
  randazzo: [450, 450, 460, 470, 480, 500, 520, 540],
  bronte: [480, 480, 500, 520, 540, 560, 580, 600],
  linguaglossa: [430, 430, 450, 470, 480, 500, 530, 580],
  santavenerina: [380, 380, 400, 420, 430, 450, 470, 500],
  zafferana: [430, 430, 450, 470, 480, 500, 530, 580],
  milo: [400, 400, 420, 440, 460, 480, 500, 520],
  solicchiata: [400, 400, 420, 440, 460, 480, 500, 520],
  rovittello: [400, 400, 420, 440, 460, 480, 500, 520],
  piedimonteetneo: [380, 380, 400, 420, 430, 450, 470, 500],
  fiumefreddodisicilia: [270, 270, 290, 320, 340, 360, 380, 400],
  calatabiano: [270, 270, 290, 320, 340, 360, 380, 400],
  mascali: [270, 270, 290, 320, 340, 360, 380, 400],
  giarre: [250, 250, 260, 280, 300, 320, 340, 360],
  acireale: [230, 230, 250, 270, 290, 320, 350, 380],
  ripostoport: [300, 300, 320, 340, 360, 380, 400, 420],

};


//одинаковые Catania airport = Catania center = Catania port
//Messina port = Messina center
//Milazzo port = Milazzo center
//Taormina = Giardini Naxos = Letojanni = (кроме цен до аэропорта Castelmola)


//- Объект с основными точками
// Значения свойств - объект с соответсвующими направлениями из этой точки
//Создаем, чтобы была связь между элементами списка SELECT и соответствующими направлениями с ценами
var mainPoints = { 
  cataniaairport: pricesCataniaAirport,
  cataniacenter: pricesCataniaAirport, //совпадает с аэропортом
  cataniaport: pricesCataniaAirport, //совпадает с аэропортом
  taormina: pricesTaormina,
  giardininaxos: pricesTaormina,
  letojanni: pricesTaormina,
  castelmola: pricesCastelmola,
  messinacenter: pricesMessina,
  messinaport: pricesMessina,
  milazzocenter: pricesMilazzo,
  milazzoport: pricesMilazzo,
  siracusa: pricesSiracusa,
  comisoairport: pricesComiso,
};

let airports = ["cataniaairport", "palermoairport", "comisoairport", "trapaniairport", "reggiocalabriaairport", "lameziatermeairport"];
let ports = ["milazzoport", "messinaport", "cataniaport", "ripostoport", "portorosaport", "trapaniport"];

var keysMainPoints = Object.keys(mainPoints); //получаем массив ("cataniaairport", "cataniacenter", "taormina" ...)

let typesRoutes = {
  "airport": {"city": "airport-city", "port": "airport-port", "airport": "airport-airport"},
  "port": {"city": "port-city", "airport": "port-airport", "port": "port-port"},
  "city": {"airport": "city-airport", "port": "city-port", "city": "city-city"},
};

